module.exports = __webpack_public_path__ + "static/img/scene1.07750d3c.jpg";